import { render, staticRenderFns } from "./SeminarCard.vue?vue&type=template&id=5cd66f2f&scoped=true&"
import script from "./SeminarCard.vue?vue&type=script&lang=js&"
export * from "./SeminarCard.vue?vue&type=script&lang=js&"
import style0 from "./SeminarCard.vue?vue&type=style&index=0&id=5cd66f2f&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Fcard-product&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd66f2f",
  null
  
)

export default component.exports